import { Backdrop as MuiBackdrop, Box, Stack, Typography } from '@mui/material'
import { FC, useMemo } from 'react'
import { Icons } from 'utoniq-ui'

import { MagazinePageDirection } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'

type Props = {
  open: boolean
  direction?: MagazinePageDirection
  onClick?: () => void
}
export const SwipeBackdrop: FC<Props> = props => {
  const { open, ...otherProps } = props

  return (
    <MuiBackdrop
      open={open}
      sx={{ zIndex: 2000, pointerEvents: 'none' }}
      {...otherProps}
    >
      <BackdropContent direction={otherProps.direction} />
    </MuiBackdrop>
  )
}

const BackdropContent: FC<{ direction?: MagazinePageDirection }> = ({
  direction,
}) => {
  const { t } = useTranslation('common')

  const Icon = useMemo(() => {
    if (direction === MagazinePageDirection.Right) {
      return Icons.Prev
    }
    if (direction === MagazinePageDirection.Left) {
      return Icons.Next
    }
    return Icons.DownArrow
  }, [direction])

  return (
    <Box
      sx={{
        margin: 'auto',
        marginTop: '250px',
        height: '200px',
        width: '200px',
        backgroundColor: 'background.default',
        opacity: 0.6,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack
        sx={{
          height: '40px',
        }}
        justifyContent="center"
        alignItems="center"
      >
        <Icon sx={{ width: 64, height: 64, color: 'grey.900' }} />
        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            color: 'grey.900',
            fontSize: 16,
            fontWeight: '600',
          }}
        >
          {direction === MagazinePageDirection.Vertical
            ? t('verticalSwipe')
            : t('horizontalSwipe')}
        </Typography>
      </Stack>
    </Box>
  )
}
